import React from 'react'
import { Tooltip } from '@mui/material'
import { styled } from '@mui/system'

interface CustomTooltipProps {
  value: string
  children: React.ReactElement
}

const StyledTooltip = styled(Tooltip)({
  '& .MuiTooltip-tooltip': {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    color: 'white',
    fontSize: '12px',
    padding: '8px 12px',
    borderRadius: '4px',
    maxWidth: '300px',
  },
  '& .MuiTooltip-arrow': {
    color: 'rgba(0, 0, 0, 0.9)',
  },
})

const CustomTooltip: React.FC<CustomTooltipProps> = ({ value, children }) => {
  if (!value) {
    return children
  }

  const formatTitle = (text: string) => {
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ))
  }

  return (
    <StyledTooltip
      title={formatTitle(value)}
      placement="bottom-start"
      arrow={true}
      disableInteractive={true}
      PopperProps={{
        style: {
          zIndex: 1200,
          pointerEvents: 'none',
        },
      }}
    >
      <span style={{ display: 'block', width: '100%', height: '100%' }}>
        {children}
      </span>
    </StyledTooltip>
  )
}

export default CustomTooltip
